import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { formatDollars } from '../../../../utils/formatting';
const printAdapter = (props)=>{
    var _deviation_print, _deviation_print1;
    const deviation = props.deviation;
    const price = ((_deviation_print = deviation.print) === null || _deviation_print === void 0 ? void 0 : _deviation_print.lowestPrice) !== undefined ? formatDollars((_deviation_print1 = deviation.print) === null || _deviation_print1 === void 0 ? void 0 : _deviation_print1.lowestPrice) : '$???';
    return _object_spread_props(_object_spread({}, props), {
        price,
        priceLabel: 'shop.thumb.from',
        priceLabelOnTop: true
    });
};
export default printAdapter;
